<template>
  <Dialog
    :is-open="isOpen"
    :title="title"
    :show-close-button="false"
    @close="cancel"
  >
    <p :class="$style.message">{{ message }}</p>
    <div :class="$style.dialogActions">
      <button :class="$style.cancelButton" @click="cancel">
        {{ cancelText }}
      </button>
      <button :class="$style.confirmButton" @click="confirm">
        {{ confirmText }}
      </button>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from "./Dialog.vue";

withDefaults(
  defineProps<{
    isOpen: boolean;
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
  }>(),
  {
    title: "Confirm Action",
    message: "Are you sure you want to proceed?",
    confirmText: "Confirm",
    cancelText: "Cancel",
  }
);

const emit = defineEmits<{
  (e: "confirm"): void;
  (e: "cancel"): void;
}>();

function confirm() {
  emit("confirm");
}

function cancel() {
  emit("cancel");
}
</script>

<style module>
.message {
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}

.dialogActions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.cancelButton {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.8);
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9em;
}

.cancelButton:hover {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border-color: rgba(255, 255, 255, 0.3);
}

.confirmButton {
  background: #e74c3c;
  border: 1px solid #c0392b;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9em;
  font-weight: 500;
}

.confirmButton:hover {
  background: #c0392b;
  border-color: #a93226;
}
</style>
